var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-redux-form';

import { FormGroup, Select } from "../../ReactReduxForms";
import { elasticLanguages } from "../../../shared/languagesList";
import t from "../../I18N/t";
import ShowIf from "../../App/ShowIf";

export class AttachmentForm extends Component {
  render() {
    const { model } = this.props;
    const validators = { originalname: { required: (val) => !!val && val.trim() !== '' } };
    const languageOptions = Object.keys(elasticLanguages).map((key) => ({
      value: elasticLanguages[key].franc,
      label: elasticLanguages[key].elastic
    }));
    languageOptions.push({ value: 'other', label: 'other' });

    return /*#__PURE__*/(
      _jsx(Form, {
        id: "attachmentForm",
        model: model,
        onSubmit: this.props.onSubmit,
        validators: validators }, void 0, /*#__PURE__*/

      _jsx(FormGroup, { model: model, field: "originalname" }, void 0, /*#__PURE__*/
      _jsx(Field, { model: ".originalname" }, void 0, /*#__PURE__*/
      _jsx("input", { className: "form-control" })
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.isSourceDocument }, void 0, /*#__PURE__*/
      _jsx(FormGroup, { className: "set-language" }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, t('System', 'Language')), /*#__PURE__*/
      _jsx(Select, { model: ".language", className: "form-control", options: languageOptions })
      )
      )
      ));

  }
}







export default connect()(AttachmentForm);